export const APP_UPDATE_SIMULATION_EVENT = 'dms:appUpdateSimulation';
